import { css } from '@eti/styles';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const DividerStyles = css`
  margin: 0 2px;
`;
const FromToLabel = _ref => {
  let {
    from,
    to
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      children: from
    }), /*#__PURE__*/_jsx("span", {
      className: DividerStyles,
      children: "\u2013"
    }), /*#__PURE__*/_jsx("span", {
      children: to
    })]
  });
};
export default FromToLabel;